// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"2c9b1ebd","249":"5d45a0a3"}[chunkId] + ".chunk.css";
};